import React, { useMemo } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./CliniciansDataTableStyles.css";
import { capitalize } from "lodash";

const CliniciansDataTable = ({ hideDemoAccounts, data, loading }) => {
  const normalizeRole = (role) => {
    return capitalize(role.replaceAll("_", " "));
  };
  let renderColumns = [
    {
      Header: "First Name",
      accessor: "first_name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value || "-"}
          </span>
        );
      },
    },
    {
      Header: "Last Name",
      accessor: "last_name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Created",
      accessor: "date_joined",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Role",
      accessor: "role",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{normalizeRole(cell.value)}</span>;
      },
    },
    {
      Header: "Contact Person",
      accessor: "clinic__clinic_group__contact_name",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value || "Not Specified"}</span>;
      },
    },
    {
      Header: "Clinic Group",
      accessor: "clinic__clinic_group__name",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return <span>{cell.value || "Not Specified"}</span>;
      },
    },
  ];

  const columns = useMemo(() => renderColumns, [loading]);

  return (
    <>
      {loading ? (
        <PatientLoader />
      ) : (
        <TableContainer
          columns={columns}
          data={data}
          hideDemoAccounts={hideDemoAccounts}
        />
      )}
    </>
  );
};

export default CliniciansDataTable;
